export default __webpack_public_path__ + "static/media/img4.68acd20b.svg";